import { Injectable } from '@angular/core';
import { SubscriptionProducts } from '@app/shared/types/enums/subscription-products.enum';
import { ICompany } from '@app/shared/types/portal/company.type';
import { find, isNil } from 'lodash';

@Injectable()
export class SubscriptionCheckService {
  public constructor() {}

  public static IsCompanyLevelActive(
    company: ICompany,
    subsProduct: SubscriptionProducts = SubscriptionProducts.XVI,
  ) {
    return !isNil(
      find(company?.subscriptions, { product: subsProduct, is_active: true }),
    );
  }
}
